////////////////////////////////////////////////////////////////////////////////////////////////
//                                                                                            //
//                        All page routs url done over here.                                  //
//                                                                                            //
////////////////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Navigate } from "react-router-dom";

// Public pages
import Login from "../pages/authentication/Login";

// Auth protected pages
import Dashboard from "../pages/dashboard/index";
import Users from "../pages/users/Users"
import Vendors from "../pages/vendors/Vendors";
import Distributors from "../pages/distributors/Distributors";
import Customers from "../pages/customers/Customers";
import Products from "../pages/products/Product";
import SubProduct from "../pages/subProducts/SubProduct";
import ProductCertification from "../pages/productCertification"
import ForgetPasswordPage from "../pages/authentication/ForgetPassword";
import ChangePassword from "../pages/authentication/ChangePassword";
import Taxations from "../pages/applicationSettings/Taxations/Taxation";
import Settings from "../pages/applicationSettings/Settings/Settings";
import Quotation from "../pages/Quotation"



// Auth protected routes
const authProtectedRoutes = [
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/users", component: <Users /> },
  { path: "/vendors", component: <Vendors /> },
  { path: "/distributors", component: <Distributors /> },
  { path: "/customers", component: <Customers /> },
  { path: "/products", component: <Products /> },
  { path: "/supported-products", component: <SubProduct /> },
  { path: "/product-certification", component: <ProductCertification /> },
  { path : "/taxations", component : <Taxations />},
  { path : "/settings", component : <Settings />},
  { path : "/quotations", component : <Quotation />}
];

// Public access routes
const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/change-password", component : <ChangePassword />}
];

export { authProtectedRoutes, publicRoutes };
